// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* INCYIA form page — matches redesign formPage shell */

.incyia-form-page {
  width: 100%;
}

.incyia-form-crumbs {
  margin-bottom: 8px;
}

.incyia-form-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.incyia-form-head-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.incyia-form-eyebrow {
  margin: 0 0 7px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #5f7484;
  font-family: Lato, sans-serif;
}

.incyia-form-title {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #00146d;
  letter-spacing: -0.02em;
  line-height: 1.15;
}

.incyia-form-sub {
  margin: 8px 0 0;
  font-size: 15px;
  color: #5f7484;
  max-width: 560px;
  line-height: 1.45;
}

.incyia-form-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 380px;
  gap: 16px;
  align-items: start;
}

@media (max-width: 1100px) {
  .incyia-form-layout {
    grid-template-columns: 1fr;
  }
}

.incyia-form-shell {
  background: #fff;
  border: 1px solid #dfe7e8;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);
  overflow: hidden;
}

.incyia-fsec {
  padding: 20px 22px;
  border-bottom: 1px solid #eaf0f0;
}

.incyia-fsec:last-of-type {
  border-bottom: none;
}

.incyia-fsec-head {
  margin-bottom: 16px;
}

.incyia-fsec-head h4 {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #0b1e2d;
}

.incyia-fsec-head p {
  margin: 4px 0 0;
  font-size: 15px;
  color: #5f7484;
  line-height: 1.45;
  max-width: 640px;
}

.incyia-fgrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  max-width: 920px;
}

.incyia-fgrid--one {
  grid-template-columns: 1fr;
}

.incyia-fgrid--three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 860px) {
  .incyia-fgrid,
  .incyia-fgrid--three {
    grid-template-columns: 1fr;
  }
}

.incyia-ffield {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.incyia-ffield--span {
  grid-column: 1 / -1;
}

.incyia-ffield-label {
  font-size: 15px;
  font-weight: 600;
  color: #0b1e2d;
  font-family: Lato, sans-serif;
  display: flex;
  align-items: center;
  gap: 4px;
}

.incyia-ffield-req {
  color: #d14a3e;
  font-size: 12px;
}

.incyia-ffield-help {
  font-size: 15px;
  color: #8a9ba7;
  line-height: 1.4;
}

/* Native + MUI inputs inside form */
.incyia-form-shell .MuiOutlinedInput-root {
  background: #fff;
  border-radius: 8px;
  font-family: Lato, sans-serif;
  font-size: 15px;
}

.incyia-form-shell .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
  border-color: #dfe7e8;
}

.incyia-form-shell .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #8a9ba7;
}

.incyia-form-shell .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #0d9b87;
  border-width: 1.5px;
}

.incyia-form-shell .MuiOutlinedInput-root.Mui-focused {
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14);
}

.incyia-form-shell .MuiInputLabel-root {
  font-family: Lato, sans-serif;
  font-size: 15px;
}

.incyia-form-shell .MuiInputLabel-root.Mui-focused {
  color: #076b5c;
}

.incyia-form-shell .MuiFormControl-root {
  width: 100%;
}

.incyia-form-inp {
  height: 40px;
  border: 1px solid #dfe7e8;
  border-radius: 8px;
  padding: 0 12px;
  background: #fff;
  font-family: Lato, sans-serif;
  font-size: 15px;
  color: #0b1e2d;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.incyia-form-inp:hover {
  border-color: #8a9ba7;
}

.incyia-form-inp:focus {
  border-color: #0d9b87;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14);
}

textarea.incyia-form-inp {
  height: auto;
  min-height: 96px;
  padding: 10px 12px;
  resize: vertical;
  line-height: 1.55;
}

.incyia-form-note {
  display: flex;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #e6eff8;
  border-left: 3px solid #22548a;
  font-size: 15px;
  color: #22548a;
  line-height: 1.5;
  grid-column: 1 / -1;
}

.incyia-form-note svg {
  flex-shrink: 0;
  margin-top: 1px;
}

/* Document selector polish inside form */
.incyia-form-shell .MuiCard-root {
  border-radius: 10px !important;
  border-color: #dfe7e8 !important;
}

.incyia-form-foot {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 14px 22px;
  background: #f7fafa;
  border-top: 1px solid #dfe7e8;
}

.incyia-form-foot-left {
  font-size: 15px;
  color: #5f7484;
}

.incyia-form-foot-right {
  margin-left: auto;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.incyia-form-foot .detail-btn:not(.detail-btn--ghost) {
  background: #0d9b87;
}

.incyia-form-foot .detail-btn:not(.detail-btn--ghost):hover {
  background: #076b5c;
}

/* Aside */
.incyia-form-aside {
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: sticky;
  top: 84px;
  align-self: start;
  overflow: visible;
}

.incyia-aside-card {
  background: #fff;
  border: 1px solid #dfe7e8;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);
  overflow: hidden;
  /* overflow:hidden makes the flex min-size 0, so a short window
     clips the note instead of letting the aside scroll. */
  flex-shrink: 0;
}

.incyia-aside-card h4 {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #0b1e2d;
  padding: 14px 16px;
  border-bottom: 1px solid #eaf0f0;
}

.incyia-aside-body {
  padding: 14px 16px;
}

.incyia-form-step {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
}

.incyia-form-step + .incyia-form-step {
  border-top: 1px solid #eaf0f0;
}

.incyia-form-step-n {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #e6eff8;
  color: #00146d;
  font-size: 14px;
  font-weight: 800;
  flex-shrink: 0;
  font-family: Lato, sans-serif;
}

.incyia-form-step b {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #0b1e2d;
  font-family: Lato, sans-serif;
}

.incyia-form-step span {
  font-size: 14px;
  color: #8a9ba7;
}

.incyia-aside-note {
  font-size: 15px;
  color: #5f7484;
  line-height: 1.5;
  margin: 0;
}

.incyia-aside-divider {
  margin-top: 10px;
  padding-top: 11px;
  border-top: 1px solid #eaf0f0;
}

.profile-layout {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

.profile-card,
.profile-forms .incyia-form-shell {
  background: #fff;
  border: 1px solid #dfe7e8;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);
  overflow: hidden;
}

.profile-hero {
  padding: 28px 20px 20px;
  text-align: center;
  background: linear-gradient(180deg, #eef3fb 0%, #fff 72%);
  border-bottom: 1px solid #eaf0f0;
}

.profile-avatar {
  width: 72px;
  height: 72px;
  margin: 0 auto 14px;
  border-radius: 50%;
  background: #00146d;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Lato, sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 0 0 6px #e4ebf6;
}

.profile-hero strong {
  display: block;
  font-family: Lato, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #0b1e2d;
}

.profile-email {
  margin: 4px 0 0;
  font-family: Lato, sans-serif;
  font-size: 14px;
  color: #5f7484;
  word-break: break-word;
}

.profile-roles {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
  margin-top: 14px;
}

.profile-role {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  border-radius: 99px;
  background: #e8eef8;
  color: #00146d;
  font-family: Lato, sans-serif;
  font-size: 12px;
  font-weight: 700;
}

.profile-meta {
  margin: 0;
  padding: 16px 18px 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.profile-meta div {
  min-width: 0;
}

.profile-meta dt {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a9ba7;
}

.profile-meta dd {
  margin: 3px 0 0;
  font-family: Lato, sans-serif;
  font-size: 14px;
  color: #0b1e2d;
  word-break: break-word;
}

.profile-forms {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.profile-pass {
  position: relative;
}

.profile-pass .incyia-form-inp {
  padding-right: 84px;
}

.profile-pass-toggle {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  padding: 4px 6px;
  color: #076b5c;
  font-family: Lato, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.profile-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

@media (max-width: 960px) {
  .profile-layout {
    grid-template-columns: 1fr;
  }
}

.profile-msg {
  margin: 12px 0 0;
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 1.45;
}

.profile-msg--error {
  color: #d14a3e;
}

.profile-msg--ok {
  color: #076b5c;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/form/form.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB;0DACwD;EACxD,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yDAAyD;EACzD,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* INCYIA form page — matches redesign formPage shell */\n\n.incyia-form-page {\n  width: 100%;\n}\n\n.incyia-form-crumbs {\n  margin-bottom: 8px;\n}\n\n.incyia-form-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n  flex-wrap: wrap;\n}\n\n.incyia-form-head-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.incyia-form-eyebrow {\n  margin: 0 0 7px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #5f7484;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-form-title {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  color: #00146d;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n}\n\n.incyia-form-sub {\n  margin: 8px 0 0;\n  font-size: 15px;\n  color: #5f7484;\n  max-width: 560px;\n  line-height: 1.45;\n}\n\n.incyia-form-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 380px;\n  gap: 16px;\n  align-items: start;\n}\n\n@media (max-width: 1100px) {\n  .incyia-form-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.incyia-form-shell {\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);\n  overflow: hidden;\n}\n\n.incyia-fsec {\n  padding: 20px 22px;\n  border-bottom: 1px solid #eaf0f0;\n}\n\n.incyia-fsec:last-of-type {\n  border-bottom: none;\n}\n\n.incyia-fsec-head {\n  margin-bottom: 16px;\n}\n\n.incyia-fsec-head h4 {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0b1e2d;\n}\n\n.incyia-fsec-head p {\n  margin: 4px 0 0;\n  font-size: 15px;\n  color: #5f7484;\n  line-height: 1.45;\n  max-width: 640px;\n}\n\n.incyia-fgrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  max-width: 920px;\n}\n\n.incyia-fgrid--one {\n  grid-template-columns: 1fr;\n}\n\n.incyia-fgrid--three {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n@media (max-width: 860px) {\n  .incyia-fgrid,\n  .incyia-fgrid--three {\n    grid-template-columns: 1fr;\n  }\n}\n\n.incyia-ffield {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.incyia-ffield--span {\n  grid-column: 1 / -1;\n}\n\n.incyia-ffield-label {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0b1e2d;\n  font-family: Lato, sans-serif;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.incyia-ffield-req {\n  color: #d14a3e;\n  font-size: 12px;\n}\n\n.incyia-ffield-help {\n  font-size: 15px;\n  color: #8a9ba7;\n  line-height: 1.4;\n}\n\n/* Native + MUI inputs inside form */\n.incyia-form-shell .MuiOutlinedInput-root {\n  background: #fff;\n  border-radius: 8px;\n  font-family: Lato, sans-serif;\n  font-size: 15px;\n}\n\n.incyia-form-shell .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n  border-color: #dfe7e8;\n}\n\n.incyia-form-shell .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #8a9ba7;\n}\n\n.incyia-form-shell .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #0d9b87;\n  border-width: 1.5px;\n}\n\n.incyia-form-shell .MuiOutlinedInput-root.Mui-focused {\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14);\n}\n\n.incyia-form-shell .MuiInputLabel-root {\n  font-family: Lato, sans-serif;\n  font-size: 15px;\n}\n\n.incyia-form-shell .MuiInputLabel-root.Mui-focused {\n  color: #076b5c;\n}\n\n.incyia-form-shell .MuiFormControl-root {\n  width: 100%;\n}\n\n.incyia-form-inp {\n  height: 40px;\n  border: 1px solid #dfe7e8;\n  border-radius: 8px;\n  padding: 0 12px;\n  background: #fff;\n  font-family: Lato, sans-serif;\n  font-size: 15px;\n  color: #0b1e2d;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.incyia-form-inp:hover {\n  border-color: #8a9ba7;\n}\n\n.incyia-form-inp:focus {\n  border-color: #0d9b87;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14);\n}\n\ntextarea.incyia-form-inp {\n  height: auto;\n  min-height: 96px;\n  padding: 10px 12px;\n  resize: vertical;\n  line-height: 1.55;\n}\n\n.incyia-form-note {\n  display: flex;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 8px;\n  background: #e6eff8;\n  border-left: 3px solid #22548a;\n  font-size: 15px;\n  color: #22548a;\n  line-height: 1.5;\n  grid-column: 1 / -1;\n}\n\n.incyia-form-note svg {\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n/* Document selector polish inside form */\n.incyia-form-shell .MuiCard-root {\n  border-radius: 10px !important;\n  border-color: #dfe7e8 !important;\n}\n\n.incyia-form-foot {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding: 14px 22px;\n  background: #f7fafa;\n  border-top: 1px solid #dfe7e8;\n}\n\n.incyia-form-foot-left {\n  font-size: 15px;\n  color: #5f7484;\n}\n\n.incyia-form-foot-right {\n  margin-left: auto;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.incyia-form-foot .detail-btn:not(.detail-btn--ghost) {\n  background: #0d9b87;\n}\n\n.incyia-form-foot .detail-btn:not(.detail-btn--ghost):hover {\n  background: #076b5c;\n}\n\n/* Aside */\n.incyia-form-aside {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  position: sticky;\n  top: 84px;\n  align-self: start;\n  overflow: visible;\n}\n\n.incyia-aside-card {\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);\n  overflow: hidden;\n  /* overflow:hidden makes the flex min-size 0, so a short window\n     clips the note instead of letting the aside scroll. */\n  flex-shrink: 0;\n}\n\n.incyia-aside-card h4 {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0b1e2d;\n  padding: 14px 16px;\n  border-bottom: 1px solid #eaf0f0;\n}\n\n.incyia-aside-body {\n  padding: 14px 16px;\n}\n\n.incyia-form-step {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 8px 0;\n}\n\n.incyia-form-step + .incyia-form-step {\n  border-top: 1px solid #eaf0f0;\n}\n\n.incyia-form-step-n {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: #e6eff8;\n  color: #00146d;\n  font-size: 14px;\n  font-weight: 800;\n  flex-shrink: 0;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-form-step b {\n  display: block;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0b1e2d;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-form-step span {\n  font-size: 14px;\n  color: #8a9ba7;\n}\n\n.incyia-aside-note {\n  font-size: 15px;\n  color: #5f7484;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.incyia-aside-divider {\n  margin-top: 10px;\n  padding-top: 11px;\n  border-top: 1px solid #eaf0f0;\n}\n\n.profile-layout {\n  display: grid;\n  grid-template-columns: 280px minmax(0, 1fr);\n  gap: 18px;\n  align-items: start;\n}\n\n.profile-card,\n.profile-forms .incyia-form-shell {\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  border-radius: 14px;\n  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);\n  overflow: hidden;\n}\n\n.profile-hero {\n  padding: 28px 20px 20px;\n  text-align: center;\n  background: linear-gradient(180deg, #eef3fb 0%, #fff 72%);\n  border-bottom: 1px solid #eaf0f0;\n}\n\n.profile-avatar {\n  width: 72px;\n  height: 72px;\n  margin: 0 auto 14px;\n  border-radius: 50%;\n  background: #00146d;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: Lato, sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1;\n  box-shadow: 0 0 0 6px #e4ebf6;\n}\n\n.profile-hero strong {\n  display: block;\n  font-family: Lato, sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #0b1e2d;\n}\n\n.profile-email {\n  margin: 4px 0 0;\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  color: #5f7484;\n  word-break: break-word;\n}\n\n.profile-roles {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 14px;\n}\n\n.profile-role {\n  display: inline-flex;\n  align-items: center;\n  height: 26px;\n  padding: 0 10px;\n  border-radius: 99px;\n  background: #e8eef8;\n  color: #00146d;\n  font-family: Lato, sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.profile-meta {\n  margin: 0;\n  padding: 16px 18px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.profile-meta div {\n  min-width: 0;\n}\n\n.profile-meta dt {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n}\n\n.profile-meta dd {\n  margin: 3px 0 0;\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  color: #0b1e2d;\n  word-break: break-word;\n}\n\n.profile-forms {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n\n.profile-pass {\n  position: relative;\n}\n\n.profile-pass .incyia-form-inp {\n  padding-right: 84px;\n}\n\n.profile-pass-toggle {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: none;\n  padding: 4px 6px;\n  color: #076b5c;\n  font-family: Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.profile-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n@media (max-width: 960px) {\n  .profile-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.profile-msg {\n  margin: 12px 0 0;\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.profile-msg--error {\n  color: #d14a3e;\n}\n\n.profile-msg--ok {\n  color: #076b5c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
